<template>
    <div class="clearfix">
      <span class="floatleft"><img src="https://escloud.digiwincloud.com/static/tw-Smart/img/logo.png"/></span>
      <ul class="floatleft menu">
        <router-link to="/home" tag="li" active-class="menuActive"><a>產品介紹</a></router-link>
        <router-link to="/project" tag="li" active-class="menuActive"><a>解決方案</a></router-link>
        <router-link to="/scene" tag="li" active-class="menuActive"><a>應用場景</a></router-link>
        <!-- <router-link to="/video" tag="li" active-class="menuActive"><a>影片教學</a></router-link> -->
        <!-- <router-link to="/dataDownload" tag="li" active-class="menuActive"><a>知識資料</a></router-link> -->
        <!-- <router-link to="/qa" tag="li" active-class="menuActive"><a>FAQ</a></router-link> -->
      </ul>
      <div class="floatleft" style="line-height: 45px;" v-if="false">
        <el-switch
          v-model="isCN"
          active-color="#13ce66"
          inactive-color="#dcdfe6"
          @change="change"
          active-text="簡體"
          inactive-text="繁體">
        </el-switch>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'OmpLink',
    data() {
      return {
        active: 1,
        isCN: false
      }
    },
    methods: {
      change(val){
        window.location.href="https://escloud.digiwincloud.com/omp-web-cn/#/home"
      }
    }
  }
</script>
<style>
.el-switch__label.is-active {
    color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/common/OmpLink.vue